/** @format */
import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

type SnackbarBodyProps = {
  variant?: 'success' | 'error' | 'warning';
};

export const SnackbarBody = styled(Box, {
  shouldForwardProp: prop => prop !== 'variant',
})<SnackbarBodyProps>(({theme, variant = 'success'}) => {
  let backgroundColor: string;

  switch (variant) {
    case 'error':
      backgroundColor = '#C06868';
      break;
    case 'warning':
      backgroundColor = '#B17629';
      break;
    case 'success':
    default:
      backgroundColor = theme.palette.figma_emerald?.main as string;
      break;
  }

  return {
    backgroundColor,
    color: '#F9FCFA',
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
  };
});
